/**
 * Keeps brand names uppercase with readable spacing.
 */
export const read_brand_input_value = (value) => {
    return `${value || ""}`.toUpperCase().replace(/\s+/g, " ");
};

/**
 * Normalizes one lead's brand list while keeping legacy brand fallback support.
 */
export const read_brand_list_values = (brands, brand) => {
    const brandValues = [
        ...[].concat(brands || []),
        brand
    ].map((value) => read_brand_input_value(value).trim()).filter(Boolean);

    return brandValues.filter((value, index, list) => list.indexOf(value) === index);
};
